import { observer } from 'mobx-react';
import React from 'react';
import CharityDataForm from '../CharityDataForm';

const CharityDataModule = observer((): JSX.Element => {
  return <CharityDataForm />;
});

export default CharityDataModule;
